<template>
    <div class="grid">
        <Toast/>
        <div class="col-12" style="max-width: 950px;">
            <div class="card">
                <h4>Estado de Resultados
                    <Tag v-if="mode" class="ml-2" :severity="mode === 'LIVE' ? 'success' : 'info'"
                         :value="mode === 'LIVE' ? 'OFICIAL' : 'VALIDACIÓN'"/>
                </h4>
                <div class="formgroup-inline">
                    <div class="field">
                        <label style="width: 90px;">Desde</label>
                        <Calendar :showIcon="true" v-model="startDate" dateFormat="yy-mm-dd"/>
                    </div>
                    <div class="field">
                        <label style="width: 90px;">Hasta</label>
                        <Calendar :showIcon="true" v-model="endDate" dateFormat="yy-mm-dd"/>
                    </div>
                    <Button label="Consultar" icon="pi pi-search" class="p-button-success mb-2"
                            :loading="loading" @click="load"/>
                </div>
            </div>
        </div>

        <div class="col-12" style="max-width: 950px;" v-if="report">
            <div class="card">
                <h5 style="color: #2e7d32;">Ingresos</h5>
                <DataTable :value="report.income" class="mb-2">
                    <Column field="code" header="Código" style="width: 120px;"></Column>
                    <Column header="Cuenta">
                        <template #body="slotProps">
                            <span :style="rowStyle(slotProps.data)">{{ slotProps.data.name }}</span>
                        </template>
                    </Column>
                    <Column header="Monto" style="width: 140px;">
                        <template #body="slotProps">${{ parseFloat(slotProps.data.amount).toFixed(2) }}</template>
                    </Column>
                </DataTable>
                <div style="display: flex; justify-content: flex-end;"><h6><b>Total ingresos: ${{ report.totalIncome }}</b></h6></div>

                <h5 style="color: #c62828;" class="mt-3">Gastos</h5>
                <DataTable :value="report.expense" class="mb-2">
                    <Column field="code" header="Código" style="width: 120px;"></Column>
                    <Column header="Cuenta">
                        <template #body="slotProps">
                            <span :style="rowStyle(slotProps.data)">{{ slotProps.data.name }}</span>
                        </template>
                    </Column>
                    <Column header="Monto" style="width: 140px;">
                        <template #body="slotProps">${{ parseFloat(slotProps.data.amount).toFixed(2) }}</template>
                    </Column>
                </DataTable>
                <div style="display: flex; justify-content: flex-end;"><h6><b>Total gastos: ${{ report.totalExpense }}</b></h6></div>

                <Divider/>
                <div style="display: flex; justify-content: flex-end; align-items: center; gap: 1rem;">
                    <h5 style="margin: 0;">Utilidad del período:</h5>
                    <h4 style="margin: 0;" :style="parseFloat(report.netIncome) >= 0 ? 'color: #2e7d32;' : 'color: #c62828;'">
                        ${{ report.netIncome }}
                    </h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import httpRequest from '../../../service/httpRequest';
import { localISODate } from '../../../service/dates';

export default {
    data() {
        const now = new Date();
        return {
            loading: false,
            startDate: new Date(now.getFullYear(), now.getMonth(), 1),
            endDate: now,
            report: null,
            mode: null,
        }
    },
    mounted() {
        this.load();
    },
    methods: {
        rowStyle(row) {
            // Las filas de GRUPO (roll-up, V2-12) son subtotales de lectura: se
            // indentan por nivel y van en negrita para no confundirlas con las
            // cuentas que sí reciben asientos. El total no las suma.
            const indent = (row.level || 0) * 14;
            return 'padding-left:' + indent + 'px;' + (row.isParent ? ' font-weight:700;' : '');
        },
        _fmt(date) {
            return localISODate(date);   // fecha local, no UTC (H64)
        },
        async load() {
            this.loading = true;
            const response = await httpRequest.getAccountingIncomeStatement(this._fmt(this.startDate), this._fmt(this.endDate));
            this.loading = false;
            if (response.status === 200) {
                this.report = response.data;
                this.mode = response.data.mode;
            } else {
                this.$toast.add({severity: 'warn', summary: 'Contabilidad', detail: response.error || 'No se pudo consultar el reporte', life: 4000});
            }
        },
    },
}
</script>
